import React, { useState, useEffect } from "react";
import anime from "animejs";
import "../styles/pages/contact.scss";
import emailjs from "emailjs-com";

function Contact({ onToast }) {
  const [status, setStatus] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (status !== "") {
      const tl = anime.timeline(),
        submitBtn = document.querySelector(".submit-btn"),
        submitText = document.querySelector(".submit-text"),
        check = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;display:inline-block"><polyline points="20 6 9 17 4 12"/></svg>`,
        error = `<span style="font-size:13px;font-weight:700">Error</span>`,
        submit = `<div class="submit-text">Submit</div>`;

      // Animate submit button to updated submission status
      tl.add({
        targets: submitText,
        opacity: [1, 0],
        duration: 300,
        delay: 1000,
      })
        .add({
          targets: submitBtn,
          width: "48px",
          begin: () => {
            status === "SUCCESS"
              ? (submitText.innerHTML = check)
              : (submitText.innerHTML = error);
          },
        })
        .add(
          {
            targets: submitText,
            opacity: [0, 1],
            duration: 5000,
          },
          "-=600"
        )
        .add(
          {
            targets: submitBtn,
            width: "140px",
            begin: () => {
              submitText.innerHTML = submit;
              setStatus("");
            },
          },
          "-=1000"
        );
    }
  }, [status]);

  function handleCopyEmail(e) {
    e.preventDefault();
    const email = "pratyushkumarrai3@gmail.com";
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(email).then(() => {
        setCopied(true);
        if (onToast) {
          onToast("📋 Email copied to clipboard: pratyushkumarrai3@gmail.com");
        }
        setTimeout(() => setCopied(false), 2500);
      });
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
    emailjs
      .sendForm(
        "service_rox9agq",
        "template_obad6em",
        event.target,
        "0uYsc3lHFEtlinSeK"
      )
      .then(
        (result) => {
          event.target.reset();
          setStatus("SUCCESS");
          if (onToast) onToast("✨ Message sent successfully! I will reply shortly.");
        },
        (error) => {
          console.error("Failed to send email:", error);
          setStatus("ERROR");
          if (onToast) onToast("⚠️ Failed to send message. Please reach me directly via email.");
        }
      );
  }

  return (
    <section id="contact" className="anchor" aria-labelledby="contact-heading">
      <div className="contact-details-col reveal-on-scroll">
        <header className="contact-header">
          <span className="section-eyebrow">CONNECT</span>
          <h2 id="contact-heading">Get in touch?</h2>
          <p>
            You can ping me anytime. Questions, collaboration opportunities, or project discussions are always welcome.
          </p>
        </header>

        <div className="contact-info">
          <h3>Contact Details</h3>
          <ul>
            <li className="contact-email-row">
              <span className="contact-icon-wrap" aria-hidden="true">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </span>
              <a href="mailto:pratyushkumarrai3@gmail.com">pratyushkumarrai3@gmail.com</a>
              <button
                type="button"
                className="copy-email-btn"
                onClick={handleCopyEmail}
                title="Copy email address"
                aria-label="Copy email address to clipboard"
              >
                <span className="copy-icon" aria-hidden="true">
                  {copied ? (
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  ) : (
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                    </svg>
                  )}
                </span>
                <span>{copied ? "Copied" : "Copy"}</span>
              </button>
            </li>
            <li>
              <span className="contact-icon-wrap" aria-hidden="true">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
              </span>
              <a href="tel:+918951369741">+91-8951369741</a>
            </li>
            <li>
              <span className="contact-icon-wrap" aria-hidden="true">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </span>
              <span>Bangalore, India</span>
            </li>
          </ul>
        </div>

        <div className="social-media">
          <ul className="social-links">
            <li>
              <a
                href="https://www.linkedin.com/in/pratyushkumarrai/"
                target="_blank"
                rel="noreferrer"
                aria-label="Pratyush Kumar Rai on LinkedIn"
                title="LinkedIn Profile"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.28 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.75M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />
                </svg>
              </a>
            </li>
            <li>
              <a
                href="https://github.com/PratyushKumarRai"
                target="_blank"
                rel="noreferrer"
                aria-label="Pratyush Kumar Rai on GitHub"
                title="GitHub Profile"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.53 1.032 1.53 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" />
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <form className="contact-form reveal-on-scroll" onSubmit={handleSubmit} noValidate={false}>
        <div className="form-row">
          <div className="form-group">
            <input
              required
              id="name"
              type="text"
              className="form-control"
              name="user_name"
              placeholder=" "
            />
            <label htmlFor="name">Name</label>
          </div>
          <div className="form-group">
            <input
              required
              id="email"
              type="email"
              className="form-control"
              aria-describedby="emailHelp"
              name="user_email"
              placeholder=" "
            />
            <label htmlFor="email">Email Address</label>
          </div>
        </div>

        <div className="form-group form-group-full">
          <input
            id="subject"
            type="text"
            className="form-control"
            name="subject"
            placeholder=" "
          />
          <label htmlFor="subject">Subject</label>
        </div>

        <div className="form-group form-group-full">
          <textarea
            required
            id="message"
            className="form-control"
            name="message"
            placeholder=" "
          ></textarea>
          <label htmlFor="message">Message</label>
        </div>

        <div className="form-submit-row">
          <button type="submit" className="submit-btn" aria-label="Submit message">
            <div className="submit-text">Submit</div>
          </button>
        </div>

        {status === "SUCCESS" && (
          <div className="form-status success" role="alert">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span>
              Message sent successfully! <br />
              I’ll get back to you shortly 😊
            </span>
          </div>
        )}

        {status === "ERROR" && (
          <div className="form-status error" role="alert">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <circle cx="12" cy="12" r="10" />
              <line x1="15" y1="9" x2="9" y2="15" />
              <line x1="9" y1="9" x2="15" y2="15" />
            </svg>
            <span>
              Something went wrong. Please email directly at pratyushkumarrai3@gmail.com
            </span>
          </div>
        )}
      </form>
    </section>
  );
}

export default Contact;